<template>
  <div
    class="e-form-search-filter"
    @keyup.enter.prevent.stop="$emit('apply')"
  >
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'e-form-search-filter',
    props: {
      formValidator: null
    }
  }
</script>
